<template>
  <!-- prettier-ignore -->
  <div v-if="isReady">
    <pin-dialog @submit="startCobrowse" />
  </div>
</template>

<script setup>
import PinDialog from './CobrowsePinDialog'
import { useLogger, useNotifications, useApplication } from '@/hooks'
import { useI18n } from 'vue-i18n'
import cobrowse$ from '@/services/Cobrowse'

// Hooks
const { logError } = useLogger()
const { addNotification } = useNotifications()
const { isReady } = useApplication()
const { t } = useI18n()

// Methods
function createCobrowseName(reason) {
  const prefix = document.body.classList.contains('chat-open') ? 'Chat' : 'Telephone'
  return `${prefix} | ${reason}`
}

function startCobrowse(data) {
  const cobrowseName = createCobrowseName(data.reason)
  cobrowse$.joinConversation(data.pin, cobrowseName).catch(e => {
    logError(['Failed starting cobrowse-session', e])
    addNotification(t('cobrowse.invalid'), 'error')
  })
}
</script>
